<template>
  <LKProgressCircular
    v-if="isLoadingAsyncData"
    overlay
    :size="50"
    style="align-items: start; padding-top: 30vh;"
  />

  <div v-else class="LKPassportMainContent">
    <ComponentFilter
      ref="filters"
      label="Поиск по логину и наименованию"
      @change="onChangeDebounced"
    />

    <BTable
      :headers="TABLE_HEADERS"
      :actions="TABLE_ACTIONS"
      :list="list"
      :pagination="pagination"
      :ordering="filters.ordering"
      :loading="isLoading"
      :skeleton="isLoadingAsyncData"
      @action:view="onShowPassport"
      @change:pagination="onChangePagination"
      @change:sort="onChangeSort"
      @action:delete="onDeleteWithRefresh"
    />
  </div>
</template>

<script>
import { LKPassportMapper as StoreMapper, LKPassportStoreModule as StoreModule } from '@/views/LKPassport/store'
import { LkPassportModel as Model } from '../../Model'
import { createListMixin } from '@/helpers/mixins/createListMixin'
import { TABLE_HEADERS, TABLE_ACTIONS } from '../../table-headers'
import { createLKPassportSchoolModal } from '@/views/LKPassport/utils'

// Components.
import ComponentFilter from './Filter.vue'
import BTable from '@/components/common/BTable.vue'
import LKProgressCircular from '@/components/lk/LKProgressCircular.vue'
import { LkPassportApi } from '@/api/resources'

const mixinOptions = { Model, StoreModule }
const listMixin = createListMixin(mixinOptions)

/** @typedef { import('@/helpers/mixins/createListMixin').ListMixin<any, StoreModule> } List */

export default {
  name: 'LKPassportMainContent',
  components: { BTable, ComponentFilter, LKProgressCircular },
  mixins: [listMixin],
  data: () => ({
    isLoadingAsyncData: false,
    TABLE_HEADERS,
    TABLE_ACTIONS,
  }),
  computed: {
    ...StoreMapper.mapState(['filters']),
  },
  methods: {
    async onShowPassport(passport, callback) {
      const unwatch = callback?.()

      try {
        const api = new LkPassportApi()
        const data = await api.getDetailedPassport(passport.id)
        const propsData = { data }
        const modal = await createLKPassportSchoolModal(this, propsData)
        modal.open()
      } catch (e) {
        this.$notice.errors(e)
      } finally {
        unwatch?.()
      }
    },
    getFilterForRequest(options) {
      const { filters, pagination } = this
      const result = {
        ...filters,
        ...options,

        ...pagination,
        page: 1,

        ate_name: options.region?.id || options.municipality?.id || options.school?.id,
        region_id: options.region?.id,
        municipality_id: options.municipality?.id,
        school_id: options.school?.id,
      }

      delete result.region
      delete result.municipality
      delete result.school
      delete result.count

      if (!result.login) {
        delete result.login
      }
      return result
    },
    async onChangeDebounced(options) {
      const p = this.getFilterForRequest(options)
      await this.onGetData(p)
    },
  },
}
</script>
